<template>
    <!--留言-->
    <div>
        <div class="smartnlp-mask"></div>
        <div class="smartnlp-leaveWords">
            <div class="smartnlp-dialog-title">请填写留言</div>
            <div class="shouming">很抱歉我们暂时无法为您提供服务，如需帮助请留言，我们将尽快回复解决您的问题</div>
            <div class="smartnlp-dialog-content">
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span>*</span>联系人</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.contactName" :maxlength="20" type="text">
                    </div>
                </div>
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span>*</span>手机</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.tel" :maxlength="11" type="text" ></div>
                </div>
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span></span>邮箱</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.email" :maxlength="20" type="text"> </div>
                </div>
                <div class="smartnlp-leaveWords-list1">
                    <div class="smartnlp-leaveWords-label" style="vertical-align: top"><span>*</span>留言内容</div>
                    <div class="smartnlp-leaveWords-right"><textarea :maxlength="200" v-model.trim="leaveMessage.context"></textarea></div>
                </div>
                <div class="smartnlp-leaveWords-submit">
                    <button type="button" style="background: #2d8ef2;" @click="save()" v-btn-control="3000">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "leave-messages",
        data() {
            return {
                sessionId:"",
                leaveMessage:{
                    companyId:'',
                    customerChannelId:'',
                    customerId:'',
                    channelId:'',
                    tel:'',
                    contactName:'',
                    email:'',
                    context:"",
                },
            }
        },
        methods:{
            save:function () {
                var _this = this;
                if(_this.leaveMessage.companyId==''||_this.leaveMessage.customerChannelId==''
                    ||_this.leaveMessage.companyId==null||_this.leaveMessage.customerChannelId==null){
                    _this.$messageBox.Error({message:"顾客信息缺失",duration:3000});
                    return;
                }
                if(_this.leaveMessage.contactName==''){
                    _this.$messageBox.Error({message:'请填写联系人',duration:3000});
                    return;
                }
                if(_this.leaveMessage.tel==''){
                    _this.$messageBox.Error({message:'请填写手机',duration:3000});
                    return;
                }
                var telReg =/^1\d{10}$/;
                if(!telReg.test(_this.leaveMessage.tel)){
                    _this.$messageBox.Error({message:'手机格式不正确',duration:3000});
                    return;
                }
                if(_this.leaveMessage.email!=''){
                    var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                    if(!emailReg.test(_this.leaveMessage.email)){
                        _this.$messageBox.Error({message:'邮箱格式不正确',duration:3000});
                        return;
                    }
                }
                if(_this.leaveMessage.context==''){
                    _this.$messageBox.Error({message:'请填写留言内容',duration:3000});
                    return;
                }
                var saveData=JSON.parse(JSON.stringify(_this.leaveMessage))
                if(_this.sessionId!=null){
                    saveData.sessionId=_this.sessionId
                }
                _this.$axiosService.post('leaveMsg/saveLeaveMsg', saveData, response => {
                    if (response.code==0) {
                        _this.$messageBox.Success({message:"已提交留言",duration:3000});
                    }else{
                        _this.$messageBox.Error({message:response.msg,duration:3000});
                    }
                });
            },
            /***
             *  【START】获取顾客信息
             * */
            getCustomerIdByCustomerChannelId:function (customerChannelId) {
              var _this = this;
                this.$axiosService.post('/customer/getCustomerIdByCustomerChannelId',{ customerChannelId:customerChannelId},function(res){
                    if(res.code==0){
                        _this.leaveMessage.customerChannelId=res.data.customerChannelId;
                        if(_this.leaveMessage.channelId!=res.data.channelId){
                            _this.leaveMessage.channelId='';
                        }
                        if(_this.leaveMessage.customerId!=res.data.customerId){
                            _this.leaveMessage.customerId='';
                        }
                        _this.getBaseCustomerById(res.data.customerId)
                    }else {
                      _this.$messageBox.Error({message:"参数customerChannelId有误",duration:3000});
                    }
                });
            },
            /***
             *  【START】获取顾客信息
             * */
            getBaseCustomerById:function (customerId) {
                var _this = this;
                _this.$axiosService.post('/customer/getBaseCustomerById',{ customerId:customerId},function(res){
                    if(res.code==0){
                        if(_this.leaveMessage.companyId!=res.data.companyId){
                            _this.leaveMessage.companyId='';
                        }
                    }else {
                        _this.$messageBox.Error({message:'不存在此用户',duration:3000});
                    }
                });
            },
        },
        computed:{
            routerQuery() {
                return this.$route.query;
            },
        },
        watch: {
            routerQuery: {
                handler(curVal, oldVal) {
                    if(curVal!=null){
                        if(curVal.companyId!=undefined&&curVal.companyId!=null){
                            this.leaveMessage.companyId=curVal.companyId;
                        }
                        if(curVal.customerId!=undefined&&curVal.customerId!=null){
                            this.leaveMessage.customerId=curVal.customerId;
                        }
                        if(curVal.channelId!=undefined&&curVal.channelId!=null){
                            this.leaveMessage.channelId=curVal.channelId;
                        }
                        if(curVal.customerChannelId!=undefined&&curVal.customerChannelId!=null){
                            this.leaveMessage.customerChannelId=curVal.customerChannelId;
                            this.getCustomerIdByCustomerChannelId(curVal.customerChannelId)
                        }
                        if(curVal.sessionId!=undefined&&curVal.sessionId!=null){
                            this.sessionId=curVal.sessionId;
                        }
                    }
                },
                deep: true,
                immediate:true,
            },
        },
    }
</script>

<style scoped>
    @import "../../../static/css/main.css";
</style>
